import { AuthPlatformEnum } from './auth-platform.enum';
import { AuthResponseModel } from './auth-response.model';
import { Verification } from './verification/verification.model';

export type LoginResponseModel = AuthResponseModel;

export class LoginBaseModel {
    token: string;
    // service version
    version = 3;
    groupInviteMode = 0;
    groupInviteKey: string;
    groupCodeMode = 0;
    groupCode: string;

    // re-captcha validation payload
    site_verify_response: Verification;

    // optional platform params, i.e., Zendesk, Smiletrain
    platform?: AuthPlatformEnum;
    returnTo?: string;
    brandId?: string;
    localeId?: string;
    timestamp?: string;

    constructor () { }
}
